/*
 *@Description: 布控管理-表格列配置
 *@Author: zhengff
 *@Date: 2019-04-26 21:55:36
 */
import { Dic } from '$utils'
import i18n from '@src/common/lib/i18n'
const faceGroup = () => {
  this.$fetch(api.queryGroup, params).then(res => {
    if(res.success){
      return  res.returnObj;
    }
  })
}
export const tableColumn = () => {
  return [
    {
      label: i18n.t('personCm.label.name'),
      prop: 'name',
      align: 'center',
      width: 200,
      overHidden: true,
      search: true,
      rules: [
        {
          required: true,
          message: i18n.t('personCm.message.choseTypes'),
          trigger: 'blur'
        }
      ]
    },
    {
      label: i18n.t('personCm.label.type'),
      prop: 'type',
      align: 'center',
      width: 200,
      search: true,
      type: 'select',
      dicData: Dic.find('SENU027001'),
      formatter: function(row, value) {
        // if (value == 2) {
        //   return i18n.t('personCm.label.blackList')
        // } else if (value == 3) {
        //   return i18n.t('personCm.label.whiteList')
        // }
        return Dic.findByValue('SENU027001', row.hitType)
      }
    },
    {
      label: i18n.t('personCm.label.cameraGroup'),
      prop: 'bayonetList',
      align: 'center',
      width: 200,
      search: true,
      searchSlot: true,
      formatter: function(row, value) {
        let str = ''
        row.cameraGoupList.map((val,index)=>{
          if (index == row.cameraGoupList.length-1) {
            str += val.bayonetName
          }else{
            str += val.bayonetName+','
          }
        });
        return (
          str
          // row.startDate + ' ' + i18n.t('personCm.title.to') + ' ' + row.endDate
        )
      }
    },
    {
      label: i18n.t('personCm.label.object'),
      prop: 'repositoriesCode',
      hide: true,
      type: 'select',
      search: true,
      searchSlot: true,
      // dicData: this.faceGroup
    },
    {
      label: i18n.t('personCm.label.state'),
      prop: 'status',
      // width: 250,
      align: 'center',
      width: 150,
      search: true,
      formatter: function(row, value) {
        if (value == 1) {
          return i18n.t('personCm.placeholder.enabled')
        }
        if (value == 2) {
          return i18n.t('personCm.placeholder.disable')
        }
      }
    },
    {
      label: i18n.t('personCm.label.describe'),
      prop: 'description',
      align: 'center',
      width: 200
    }
  ]
}


